import styled from 'styled-components';

import { Box } from '../../units/Box/Box';

const Layout = styled(Box)`
  max-width: 720px;
  min-width: 720px;
  min-height: 860px;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  background-color: #ffffff;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
`;

export default Layout;



// WEBPACK FOOTER //
// ./src/components/layout/Layout/Layout.js